import { render } from "./ycmx.vue?vue&type=template&id=28ada946&scoped=true&ts=true"
import script from "./ycmx.vue?vue&type=script&lang=ts"
export * from "./ycmx.vue?vue&type=script&lang=ts"

import "./ycmx.vue?vue&type=style&index=0&id=28ada946&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ada946"]])

export default __exports__